import PropTypes from "prop-types";
import { useEffect } from "react";

// Layouts
import SingleTiersLoader from "@/Layouts/components/Skeletons/SingleTiersLoader";

// Custom components
import ContractsInTransit from "@/PayPlans/components/Defaults/Managers/Finance/ContractsInTransit";

// MUI
import { Grid } from "@mui/material";

export default function CITBonus(props) {
	const {
		sectionId = "cit",
		content = null,
		citTypes = ["Dollars", "Contracts"],
		loading = false,
		readOnly = false,
		onActionUpdate = () => {},
		useSectionsErrors = () => {},
	} = props;

	const { addSectionError, removeSectionError, clearSectionErrors } = useSectionsErrors?.() || {};

	const handleUpdate = (updatedModel) => {
		onActionUpdate?.(sectionId, null, updatedModel);
	};

	const handleValidation = (isValid) => {
		isValid ? removeSectionError?.(sectionId) : addSectionError?.(sectionId);
	};

	useEffect(() => {
		return () => {
			clearSectionErrors?.(sectionId);
		};
	}, [sectionId, clearSectionErrors]);

	return (
		<Grid container>
			<Grid item xs={12} mt={2.5} px={"32px"}>
				{loading ? (
					<SingleTiersLoader tiers={1} mt={1} buttons sx={{ padding: 0 }} />
				) : (
					<Grid container>
						<Grid item xs={12} className={"models-tiered-area"}>
							<ContractsInTransit
								model={content}
								citTypes={citTypes}
								readOnly={readOnly}
								onActionUpdate={handleUpdate}
								onActionValidation={handleValidation}
							/>
						</Grid>
					</Grid>
				)}
			</Grid>
		</Grid>
	);
}
CITBonus.propTypes = {
	sectionId: PropTypes.string,
	content: PropTypes.object,
	citTypes: PropTypes.array,
	useSectionsErrors: PropTypes.func,
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
};
